import styles from './styles/PartnersLinkPanel.css'
import { Link, useLocation } from 'react-router-dom'
import classNames from 'classnames'

const PartnersLinkPanel = ({ homePage = false }) => {
  const { pathname } = useLocation()
  return (
    <div className={styles.container}>
      <div className={classNames(styles.partnersLearnMorePanel, {
        [styles.border]: pathname === '/'
      })}
      >
        <Link
          className={classNames(styles.learnMoreLink, {
            [styles.currentLocation]: pathname === '/partners/pharmaceuticals-and-biotech',
            [styles.homepage]: homePage
          })} to='/partners/pharmaceuticals-and-biotech'
        >For Pharmaceuticals & Biotech
          {pathname === '/partners/pharmaceuticals-and-biotech' && <div className={styles.currentArrowContainer}><div className={classNames(styles.currentArrow, styles.randd)} /> </div>}
        </Link>
        <Link
          className={classNames(styles.learnMoreLink, {
            [styles.currentLocation]: pathname === '/partners/academic-institutions',
            [styles.homepage]: homePage
          })} to='/partners/academic-institutions'
        >For Universities & Libraries
          {pathname === '/partners/academic-institutions' && <div className={styles.currentArrowContainer}><div className={classNames(styles.currentArrow, styles.institutions)} /> </div>}
        </Link>
        <Link
          className={classNames(styles.learnMoreLink, {
            [styles.currentLocation]: pathname === '/partners/researchers',
            [styles.homepage]: homePage
          })} to='/partners/researchers'
        >For Researchers
          {pathname === '/partners/researchers' && <div className={styles.currentArrowContainer}><div className={classNames(styles.currentArrow, styles.researchers)} /> </div>}
        </Link>
        <Link
          className={classNames(styles.learnMoreLink, {
            [styles.currentLocation]: pathname === '/partners/students',
            [styles.homepage]: homePage
          })} to='/partners/students'
        >For Students
          {pathname === '/partners/students' && <div className={styles.currentArrowContainer}><div className={classNames(styles.currentArrow, styles.funders)} /> </div>}
        </Link>
        <Link
          className={classNames(styles.learnMoreLink, {
            [styles.currentLocation]: pathname === '/partners/publishers',
            [styles.homepage]: homePage
          })} to='/partners/publishers'
        >For Publishers
          {pathname === '/partners/publishers' && <div className={styles.currentArrowContainer}><div className={classNames(styles.currentArrow, styles.publisher)} /> </div>}
        </Link>
      </div>
    </div>
  )
}

export default PartnersLinkPanel
